import React, { Component } from 'react';
import { Link } from "@mui/material";

import loginPageCss from "../css/loginPage.module.css";
import "../css/loginPage.css"

class JoinHeader extends Component {
    constructor(props) {
        super(props);

        this.handleLogoClick = this.handleLogoClick.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    handleLogoClick() {
        const { hstate } = this.props;
        let url = `/intro`
        if(hstate) url += `?state=${hstate}`;
        window.location.href = url;
    }

    handlePageChange(e) {
        const { RegisterAction } = this.props;
        RegisterAction.setPage(Number(e.target.value));
    }

    render() {
        const { children } = this.props;
        const { joinStep, noAccess12, noAccess1 } = this.props;
        const { handleLogoClick, handlePageChange } = this;

        return (
            <>
                <div className="text-center">
                    {/*<Link href={"/"}><img className={`${loginPageCss["register-logo"]}`} src="/assets/img/logo.svg"/></Link>*/}
                    <img className={`${loginPageCss["register-logo"]}`} src="/assets/img/logo.svg" onClick={handleLogoClick}/>
                </div>
                <section className={`container-fluid`}>
                    {/*/!*화면 설계도 6~ 14까지에 대한 페이지*!/*/}
                    {/*/!*kko = 1이면 회원정보를 불러오는 중이라고 알려줌*!/*/}
                    {/*{kko === "1" && <div>회원정보를 불러오는 중입니다!</div>}*/}
                    {/*{kko !== "1" &&*/}
                        <div className='row justify-content-center'>
                            <div className='row justify-content-center'>
                                <div
                                    className={`col-lg-4 d-flex justify-content-center align-items-center mt-3 mb-5 ${loginPageCss["step-number"]}`}>

                                    {/*1번페이지에서 모든 항목에 대해 동의하지 않으면 2번으로 넘어갈 수 없음 or 카카오 로그인일경우 1번으로 갈 수 없다.*/}
                                    {/*3번 페이지에서 1,2번 페이지로 넘어갈 수 없음*/}
                                    <div className={`btn-group ${loginPageCss["btn-group"]} mx-2 z-0`}>
                                        <input className={`${loginPageCss["btn-check"]} btn-check`} type="radio" name="registerPage" id="registerPage1"
                                               value="1" onChange={handlePageChange} checked={joinStep === 1}
                                               disabled={joinStep !== 1}
                                               // disabled={noAccess12 || noAccess1}
                                        />
                                        <label className={`btn btn-primary ${loginPageCss["btn"]} `} htmlFor="registerPage1">
                                            1
                                        </label>
                                    </div>
                                    <div className={loginPageCss["bs-stepper-line"]}/>
                                    <div className={`btn-group ${loginPageCss["btn-group"]} mx-2 z-0`}>
                                        <input className={`${loginPageCss["btn-check"]} btn-check`} type="radio" name="registerPage" id="registerPage2"
                                               value="2" onChange={handlePageChange} checked={joinStep === 2}
                                               disabled={joinStep !== 2}
                                               // disabled={!(agree.spam && agree.personal && agree.service && agree.data && agree.marketing) || noAccess12}
                                        />
                                        <label className={`btn btn-primary ${loginPageCss["btn"]}`} htmlFor="registerPage2">
                                            2
                                        </label>
                                    </div>
                                    <div  className={loginPageCss["bs-stepper-line"]}/>
                                    <div className={`btn-group ${loginPageCss["btn-group"]} mx-2 z-0`}>
                                        <input className={`${loginPageCss["btn-check"]} btn-check`} type="radio" name="registerPage" id="registerPage3"
                                               value="3"
                                               onChange={handlePageChange} checked={joinStep === 3}
                                               disabled={joinStep !== 3}
                                               // disabled={!(agree.spam && agree.personal && agree.service && agree.data && agree.marketing) || !noAccess12}
                                        />
                                        <label className={`btn btn-primary ${loginPageCss["btn"]}`} htmlFor="registerPage3">
                                            3
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div className={`${loginPageCss["body-bg"]} row justify-content-center align-items-center`}>
                                <div className={`${loginPageCss["step-two"]} col-lg-4 d-flex justify-content-center mb-5`}>
                                    {children}
                                </div>
                            </div>
                        </div>
                    {/*}*/}
                </section>
            </>
        )
    }
}

export default JoinHeader;
